export default __webpack_public_path__ + "static/media/distanstolkning1.3333725f.png";